import { Outlet } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { TopBar } from './TopBar';
import { Footer } from './Footer';
import { useClaimGuestRun } from '../../hooks/useClaimGuestRun';

/**
 * Three-zone shell (spec 10.2): TopBar · scrollable MainContent · BottomBar.
 * The BottomBar is game-screen-only and is rendered by the Game page itself
 * (it needs live rack state); the shell reserves no space for it elsewhere.
 * A Footer with legal links sits below the content on every page.
 */
export function PageShell() {
  // A guest run waiting in localStorage is claimed the moment a session exists —
  // covers register→verify, Google callback, and login after guest play.
  useClaimGuestRun();
  // HelmetProvider lives here (not main.tsx) so every route — and every test
  // that mounts the route table directly — can render <Seo> head tags.
  return (
    <HelmetProvider>
      <div className="flex min-h-full flex-col">
        <TopBar />
        <main className="mx-auto w-full max-w-content flex-1 px-4 pb-8 pt-4">
          <Outlet />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
